<script setup lang="ts">
import { environment } from '@/utils/environment'

const refName = import.meta.env.VITE_CI_COMMIT_REF_NAME || 'LOCAL'
</script>

<template>
  <div class="env-info-bar">
    <p class="text-xs md:text-lg mr-8">Branch: {{ refName.toUpperCase() }}</p>

    <p class="text-xs md:text-lg mr-8">
      App: {{ environment().toUpperCase() }}
    </p>
  </div>
</template>

<style>
@reference "#tailwind";

.env-info-bar {
  @apply sticky flex flex-wrap justify-center items-center h-10 bg-primary-900 bottom-0 left-0 right-0 text-neutral-0 z-10;
}
</style>
